<!-- 首页库存页 -->
<template>
  <div class="app-container">
    <el-row :gutter="8">
      <el-col :xs="24" :sm="8">
        <el-card class="top-card-height">
          <el-divider>库存</el-divider>
          <div style="padding: 30px 0 20px 0">
            <div class="text-center font-size30">
              <span class="text-style" style="color: #75c84d"> 总库存 </span>
              <el-statistic :value="total" />
            </div>
            <el-row class="mt25 font-size24">
              <el-col :span="8">
                <div class="text-center">
                  <div class="text-style">主材</div>
                  <div class="mt10">
                    <el-statistic :value="zcount" />
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="text-center">
                  <div class="text-style">辅材</div>
                  <div class="mt10"><el-statistic :value="fcount" /></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="text-center">
                  <div class="text-style">耗材</div>
                  <div class="mt10">
                    <el-statistic :value="hcount" />
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="16">
        <el-card class="top-card-height">
          <el-divider>出入库统计</el-divider>
          <el-row :gutter="8">
            <el-col :span="1.5">
              <el-button
                :class="{ 'active-class': active === 'today' }"
                @click="changeActive('today')"
                >今天</el-button
              >
            </el-col>
            <el-col :span="1.5">
              <el-button
                :class="{ 'active-class': active === 'yesterday' }"
                @click="changeActive('yesterday')"
                >昨天</el-button
              >
            </el-col>
            <el-col :span="1.5">
              <el-button
                :class="{ 'active-class': active === 'week' }"
                @click="changeActive('week')"
                >本周</el-button
              >
            </el-col>
            <el-col :span="1.5">
              <el-button
                :class="{ 'active-class': active === 'month' }"
                @click="changeActive('month')"
                >本月</el-button
              >
            </el-col>
            <el-col :span="1.5">
              <el-button
                :class="{ 'active-class': active === 'quarter' }"
                @click="changeActive('quarter')"
                >本季度</el-button
              >
            </el-col>
            <el-col :span="1.5">
              <el-button
                :class="{ 'active-class': active === 'year' }"
                @click="changeActive('year')"
                >本年</el-button
              >
            </el-col>
          </el-row>
          <div v-loading="outInOverviewLoading">
            <el-row class="mt25">
              <el-col :span="6"> </el-col>
              <el-col :span="6">
                <div class="text-center">主材</div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">辅材</div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">耗材</div>
              </el-col>
            </el-row>
            <el-row class="mt25 in-class">
              <el-col :span="6">
                <div class="text-center">
                  入库数：{{ outInOverviewData.inTotal }}
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">{{ outInOverviewData.inZtotal }}</div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">{{ outInOverviewData.inFtotal }}</div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">{{ outInOverviewData.inHtotal }}</div>
              </el-col>
            </el-row>
            <el-row class="mt25 out-class">
              <el-col :span="6">
                <div class="text-center">
                  出库数：{{ outInOverviewData.outTotal }}
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">{{ outInOverviewData.outZtotal }}</div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">{{ outInOverviewData.outFtotal }}</div>
              </el-col>
              <el-col :span="6">
                <div class="text-center">{{ outInOverviewData.outHtotal }}</div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="8">
      <el-col :xs="24" :sm="8">
        <el-card style="height: 400px">
          <el-divider>产品库存</el-divider>
          <Table
            style="margin-bottom: 80px"
            height="340px"
            :infiniteScroll="true"
            ref="productTableRef"
            :isCreateSearch="false"
            :showFun="false"
            :pageSize="20"
            :pageTotal="productPageTotal"
            :data="productTableData"
            :columns="productTableColmuns"
            :loading="productTableLoading"
            @onScrollSearch="getProductData"
          >
          </Table>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="16">
        <el-card style="height: 400px; padding: 0px">
          <el-divider>产品类型库存</el-divider>
          <div v-show="chartTotal === 0">
            <el-empty :image-size="200" />
          </div>
          <div ref="chartRef" style="width: 100%; height: 300px"></div>
          <div
            style="
              position: relative;
              display: flex;
              justify-content: center; /* 水平居中，如果需要的话 */
            "
          >
            <el-pagination
              v-show="chartTotal > 0"
              style="position: absolute; bottom: -10px"
              :background="true"
              :page-size="20"
              :pager-count="5"
              layout="total,prev, pager,next"
              :total="chartTotal"
              v-model:current-page="currentPage"
              @currentChange="getProductTypeData"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  ref,
  getCurrentInstance,
  nextTick,
  watch,
} from "vue";
import {
  selectOutInProductOverview,
  selectProductInventory,
  selectProductTypeInventory,
} from "@/api/warehouse/statistics";
import Table from "@/components/Element/Table";
import { getCustomTableCols } from "@/tableColumn";
import * as echarts from "echarts";
import { useTransition } from "@vueuse/core";
import useCacheStore from "@/store/modules/cache";

const cacheStore = useCacheStore();

const { getDictNameByPCodeSCode } = cacheStore;

const { proxy } = getCurrentInstance();

const props = defineProps({
  data: {
    require: true,
    type: Object,
  },
  activeKey: {
    require: true,
    type: String,
  },
});

const active = ref("today");

const totalSource = ref(0);
const zcountSource = ref(0);
const fcountSource = ref(0);
const hcountSource = ref(0);

// 获取总览数据
const getOverviweData = () => {
  let zcount = 0;
  let fcount = 0;
  let hcount = 0;
  props.data.inventoryOverviewEntityList.forEach((item) => {
    switch (item.usageType) {
      case "1":
        if (item.productNum) {
          zcount = item.productNum;
        }

        break;
      case "2":
        if (item.productNum) {
          fcount = item.productNum;
        }
        break;
      case "3":
        if (item.productNum) {
          hcount = item.productNum;
        }
        break;
      default:
        break;
    }
  });
  totalSource.value = zcount + fcount + hcount;
  zcountSource.value = zcount;
  fcountSource.value = fcount;
  hcountSource.value = hcount;
};

const total = useTransition(totalSource, {
  duration: 1000,
});

const zcount = useTransition(zcountSource, {
  duration: 1000,
});

const fcount = useTransition(fcountSource, {
  duration: 1000,
});

const hcount = useTransition(hcountSource, {
  duration: 1000,
});

const outInOverviewLoading = ref(false);
const outInOverviewData = ref({
  inTotal: 0,
  inZtotal: 0,
  inFtotal: 0,
  inHtotal: 0,
  outTotal: 0,
  outZtotal: 0,
  outFtotal: 0,
  outHtotal: 0,
});

const changeActive = (dateStr) => {
  active.value = dateStr;
  outInOverviewLoading.value = true;
  selectOutInProductOverview(props.data.warehouseId, dateStr)
    .then((res) => {
      let inZtotal = 0;
      let inFtotal = 0;
      let inHtotal = 0;
      let outZtotal = 0;
      let outFtotal = 0;
      let outHtotal = 0;
      res.data.forEach((item) => {
        if (item.status === "1") {
          switch (item.usageType) {
            case "1":
              inZtotal = item.productNum;
              break;
            case "2":
              inFtotal = item.productNum;
              break;
            case "3":
              inHtotal = item.productNum;
              break;
          }
        }
        if (item.status === "2") {
          switch (item.usageType) {
            case "1":
              outZtotal = item.productNum;
              break;
            case "2":
              outFtotal = item.productNum;
              break;
            case "3":
              outHtotal = item.productNum;
              break;
          }
        }
      });
      outInOverviewData.value = {
        inTotal: inZtotal + inFtotal + inHtotal,
        inZtotal: inZtotal,
        inFtotal: inFtotal,
        inHtotal: inHtotal,
        outTotal: outZtotal + outFtotal + outHtotal,
        outZtotal: outZtotal,
        outFtotal: outFtotal,
        outHtotal: outHtotal,
      };
    })
    .catch((err) => {})
    .finally(() => {
      outInOverviewLoading.value = false;
    });
};

/*
  产品库存
*/
const productTableData = ref([]);
const productPageTotal = ref(1);
const productTableLoading = ref(false);
const productTableRef = ref(null);
const productTableColmuns = getCustomTableCols([
  "productName",
  "productType",
  {
    label: "产品数量",
    prop: "productNum",
    propType: "number",
    itemWidth: "102",
  },
]);

const getProductData = (data) => {
  selectProductInventory({
    warehouseId: props.data.warehouseId,
    ...data,
  })
    .then((res) => {
      productTableData.value = productTableData.value.concat(res.data);
      productPageTotal.value = res?.pageParam?.totlePage
        ? res.pageParam.totlePage
        : 0;
    })
    .catch((res) => {})
    .finally(() => {});
};

/*
  产品类型库存
*/
const currentPage = ref(1);
const chartRef = ref(null);
const chartTotal = ref(0);
let myChart = null;
const chartInit = () => {
  proxy.$nextTick(() => {
    myChart = echarts.init(chartRef.value);
    myChart.setOption({
      tooltip: {},
      xAxis: {
        data: [],
        axisLabel: {
          rotate: 30,
        },
      },
      grid: {
        bottom: "30%",
        top: "10%",
      },
      yAxis: {},
      series: [
        {
          name: "库存",
          type: "bar",
          label: {
            show: true, // 开启标签显示
            position: "top", // 将标签放在柱子的最顶部位置
            formatter: "{c}", // 格式化标签内容，{c}表示取原始数据中对应索引的值
            color: "#333", // 文本样式设置
          },
          data: [],
        },
      ],
    });
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  });
};

const getProductTypeData = () => {
  myChart?.showLoading();
  selectProductTypeInventory({
    warehouseId: props.data.warehouseId,
    pageIndex: currentPage.value,
    pageSize: 20,
  })
    .then((res) => {
      const xAxisList = [];
      const yAxisList = [];
      chartTotal.value = res.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
      res.data.forEach((item) => {
        xAxisList.push(
          getDictNameByPCodeSCode("productType", item.productType)
        );
        yAxisList.push(item.productNum);
      });
      myChart.setOption({
        xAxis: {
          data: xAxisList,
        },
        series: {
          data: yAxisList,
        },
      });
    })
    .catch((err) => {})
    .finally(() => {
      myChart?.hideLoading();
    });
};

const getData = () => {
  if (props.data.warehouseId === props.activeKey) {
    if (myChart === null) {
      nextTick(() => {
        chartInit();
      });
    }
    changeActive(active.value);
    if (productTableRef.value !== null) {
      productTableData.value = [];
      productTableRef.value.onSearch();
    }
    getProductTypeData();
  }
};

defineExpose({
  getData,
});

onMounted(() => {
  getData();
  //

  watch(
    () => props.activeKey,
    (newVal) => {
      getData();
      // nextTick(() => {
      //   myChart && myChart.resize();
      // });
    }
  );

  watch(
    () => props.data,
    (newVal) => {
      getOverviweData();
    },
    {
      immediate: true,
    }
  );
});
</script>

<style lang="scss" scoped>
.active-class {
  background-color: #409eff !important;
  color: #fff;
  border-color: #409eff;
}
.top-card-height {
  height: 250px;
}

.container {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中，如果需要的话 */
  // height: 100vh; /* 或者其他高度 */
}

.text-style {
  // font-size: 30px;
  font-weight: 500;
  color: #409eff;
}

.text-center {
  text-align: center;
}

.in-class {
  color: #409eff;
}

.out-class {
  color: #e4a318;
}
</style>
